import {
  Box,
  Container,
  Grid,
  Group,
  Paper,
  ScrollArea,
  Skeleton,
  Stack,
} from '@mantine/core'
import React from 'react'

interface CommonProps extends React.ComponentPropsWithoutRef<typeof Paper> {
  h?: string | number
  children: React.ReactNode
}

const AppContainer = ({ h, children, ...otherProps }: CommonProps) => {
  return (
    <ScrollArea component={Paper} {...otherProps} h={h}>
      <Stack h="100%">{children}</Stack>
    </ScrollArea>
  )
  return (
    <Group
      p="xl"
      bg="orange"
      style={{
        overflow: 'auto',
        display: 'block',
        height: '100%',
        maxHeight: '100%',
      }}
    >
      <Stack
        h="100%"
        bg="yellow"
        style={{
          overflow: 'scroll !important',
          height: '100% important!',
          maxHeight: '100% important!',
        }}
      >
        {Array.from({ length: 50 }).map((_, index) => (
          <Group bg="green" key={index}>
            Loading...
          </Group>
        ))}
      </Stack>
      {/* {Array.from({ length: 50 }).map((_, index) => (
      <div key={index}>Loading...</div>
      ))} */}

      {/* {children} */}

      {/* <Paper
      {...otherProps}
      >
      {children}
      </Paper> */}
    </Group>
  )
}

export default AppContainer
